import VerifyBox from './VerifyBox';
export { VerifyBox };
export default VerifyBox;
